import { useEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Skeleton, Stack } from '@mui/material';
import {useTranslation} from "react-i18next";

am4core.useTheme(am4themes_animated);

const ChartTwo = ({ data, name, className }) => {
    const [showLoader, setShowLoader] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        // Create chart instance
        let chart = am4core.create(name, am4charts.XYChart);

        chart.events.on('ready', () => {
            setShowLoader(false);
        });

        // Sample data
        chart.data = data['data'];
        let legendData = data['legend'];

        // Create category axis (X-axis)
        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "category";
        categoryAxis.renderer.labels.template.disabled = true;
        // categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 20;
        categoryAxis.renderer.labels.template.fontSize = 14;
        categoryAxis.renderer.labels.template.fontWeight = "bold";

        // Create value axis (Y-axis) for bar chart
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.min = 0;
        valueAxis.extraMax = 0.15; // Add extra space on the right side
        valueAxis.title.text = t('LOCAL_INDICATORS.IN_MILLION_ALL');

        // Create secondary Y-axis for percentage values (Right Side)
        let percentageAxis = chart.yAxes.push(new am4charts.ValueAxis());
        percentageAxis.renderer.opposite = true;  // Place axis on the right side
        percentageAxis.min = 80;  // Adjust minimum value
        // percentageAxis.max = 120; // Adjust maximum value
        percentageAxis.renderer.labels.template.adapter.add("text", function(text) {
            return text + "%";  // Add percentage sign to labels
        });
        percentageAxis.renderer.grid.template.disabled = true; // Hide grid lines

        // Create plan column series
        let planSeries = chart.series.push(new am4charts.ColumnSeries());
        planSeries.dataFields.valueY = "plan";
        planSeries.dataFields.categoryX = "category";
        planSeries.name = legendData['plan'];
        planSeries.columns.template.tooltipText = "{name}: {valueY}";
        planSeries.columns.template.width = am4core.percent(40);
        planSeries.fill = am4core.color("#008080"); // Orange color
        planSeries.stroke = planSeries.fill;

        // Create actual column series
        let actualSeries = chart.series.push(new am4charts.ColumnSeries());
        actualSeries.dataFields.valueY = "factual";
        actualSeries.dataFields.categoryX = "category";
        actualSeries.name = legendData['factual'];
        actualSeries.columns.template.tooltipText = "{name}: {valueY}";
        actualSeries.columns.template.width = am4core.percent(40);
        actualSeries.fill = am4core.color("#FFA500"); // Teal color
        actualSeries.stroke = actualSeries.fill;


        // Add individual percentage bullets without connecting lines
        let percentageSeries = chart.series.push(new am4charts.LineSeries());
        percentageSeries.dataFields.valueY = "realization";
        percentageSeries.dataFields.categoryX = "category";
        percentageSeries.name = legendData['realization'];
        percentageSeries.strokeWidth = 0; // Remove line by setting strokeWidth to 0

        // Add red bullets for percentage points
        let bullet = percentageSeries.bullets.push(new am4charts.CircleBullet());
        bullet.circle.fill = am4core.color("#FF0000"); // Red color
        bullet.circle.radius = 7;
        bullet.circle.strokeWidth = 0; // Remove circle border

        // Add percentage labels above the bullets
        let labelBullet = percentageSeries.bullets.push(new am4charts.LabelBullet());
        labelBullet.label.text = "{valueY}%";
        labelBullet.label.fill = am4core.color("#FF0000"); // Red text
        labelBullet.dy = -20; // Position label above the bullet
        labelBullet.label.fontSize = 18;
        labelBullet.label.fontWeight = "bold";
        labelBullet.tooltipText = "{valueY}%";

        // Assign percentage series to the secondary Y-axis
        percentageSeries.yAxis = percentageAxis;

        // Add legend
        chart.legend = new am4charts.Legend();
        chart.legend.position = "bottom";

        // Add cursor
        chart.cursor = new am4charts.XYCursor();

        return () => {
            chart.dispose(); // Cleanup on unmount
        };
    }, []);

    return (
        <>
            <div id={name} style={{width: showLoader ? '0' : '100%', height: showLoader ? '0' : '700px'}} className={className}></div>
            {showLoader && (
                <Stack spacing={1}>
                    <Skeleton variant="text" />
                    <Skeleton variant="rounded" width={'auto'} height={500} />
                </Stack>
            )}
        </>
    );
};

export default ChartTwo;
